const LIGHT_THEME_COLOR = "#ffffff";
const DARK_THEME_COLOR = "#1a1a1a";

export function applyThemeColor(isDarkMode) {
  let meta = document.querySelector('meta[name="theme-color"]');

  if (!meta) {
    meta = document.createElement("meta");
    meta.name = "theme-color";
    document.head.appendChild(meta);
  }

  meta.setAttribute(
    "content",
    isDarkMode ? DARK_THEME_COLOR : LIGHT_THEME_COLOR,
  );
}
